import { render, staticRenderFns } from "./ConfirmSaveAssignments.vue?vue&type=template&id=62937f8a&"
import script from "./ConfirmSaveAssignments.vue?vue&type=script&lang=js&"
export * from "./ConfirmSaveAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports